import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import styles from './smart-records-panel.module.css';
import SmartRecordsController from '../../controllers/SmartRecordsController';
import RefreshButton from './RefreshButton';
import classNames from 'classnames';

const EmptyState: React.FC = () => {
  const controller = useController(SmartRecordsController);
  return (
    <div className={styles.panelItem}>
      <div className={classNames(styles.emptyStateActions, 'mb-5')}>
        <RefreshButton />
      </div>
      <div className={styles.empty}>
        <span>No Aha! shapes in this whiteboard.</span>
        <span
          className={styles.emptyAddRecord}
          onClick={() => {
            controller.actionAddSmartRecord();
          }}
        >
          <i className='fa-light fa-circle-plus' style={{ fontSize: '12px' }} />{' '}
          Add an Aha! shape to get started
        </span>
      </div>
    </div>
  );
};

export default ApplicationView(EmptyState);
